import Request from '@/utils/request';

//账单应收列表
export function getBillList(data) {
  return Request('post', '/apd/finance/bill/billList', data)
}
//账单应收详情
export function getBillInfo(data) {
  return Request('post', '/apd/finance/bill/billInfo', data)
}